import React, { useState, useEffect } from "react";
import Button from "@components/Button";
import { Home } from "@mui/icons-material";
import { useNavigate } from "react-router";
import styles from "./ViewProgressPage.module.css";
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import TicketUpdateComponent from "@components/TicketUpdate/TicketUpdateComponent";
import TicketBoardComponent from "@components/TicketBoard/TicketBoardComponent";
import CustomInput, { CustomSelectInput } from "@components/CustomInput/CustomInput";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import useTicket from "@hooks/useTicket";

const ViewProgressPage = () => {
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [step, setStep] = useState("manage");
  const [showTicketUpdate, setShowTicketUpdate] = useState(false);
  const [selectedTicket, setSelectedTicket] = useState(null);
  const ticketData = useSelector((state) => state.ticket.ticketData);
  const { handleGetSupportTicket } = useTicket();
  const [refreshTickets, setRefreshTickets] = useState(false);
  const [searchFilters, setSearchFilters] = useState({
      id: "",
      userType: "",
      firstName: "",
      startDate: null,
      endDate: null,
      type: "report",
      source: "",
  });

  useEffect(() => {    
      handleGetSupportTicket({ 
        ...searchFilters
      });
  },[refreshTickets]);

  const handleSearchInput = ({ target }) => {
    const { name, value } = target;
    setSearchFilters((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleOpenTicketUpdate = (doctor) => {
    setSelectedTicket(doctor);
    setShowTicketUpdate(true);
  };

  const handleNavigateViewTicket = (user) => {
    navigate("/ticketsupport/viewticket", {
        state: { stages: user }
    });
};


  const handleNavigateDashboard = () => {
    navigate("/");
  };

  const handleNavigateTicketSupport = () => {
    navigate("/ticketsupport");
  };

  const searchFunction = () => {    
    handleGetSupportTicket(searchFilters);
  };

  return (
    <>
        <div className={styles.MenuWrapper}>
            <div className={styles.NavigationWrapper}>
                <Home className={styles.HomeIcon} onClick={handleNavigateDashboard} />{" "}
                <div>
                <span
                className={styles.DashboardText}
                onClick={handleNavigateDashboard}
                >
                Dashboard
                </span>
                <span 
                className={styles.DashboardText}
                onClick={handleNavigateTicketSupport}>/Ticket Support</span>
                <span className={styles.RouteText}>/View Progress</span>
                </div>
            </div>
            <div className={styles.ActionItemsWrapper}>
            <Button
                className={styles.BtnClass}
                text={"View New Tickets"}
                btnType={"secondary"}
                onClick={handleNavigateTicketSupport}
            />
            </div>
        </div>
        <div className={styles.searchWrapper}>
          <CustomSelectInput
            className={styles.CustomSelect}
            selectOptions={[
              { option: "Report", value: "report" },
              { option: "Contact", value: "contact" },
            ]}
            name={"type"}
            value={searchFilters.type}
            onChange={handleSearchInput}
            defaultOption={"Type"}
          />
          <CustomSelectInput
            className={styles.CustomSelect}
            selectOptions={[
              { option: "Doctor", value: "doctor" },
              { option: "Patient", value: "patient" },
            ]}
            name={"userType"}
            value={searchFilters.userType}
            onChange={handleSearchInput}
            defaultOption={"User Type"}
          />
          <CustomSelectInput
            className={styles.CustomSelect}
            selectOptions={[
              { option: "Vision Therapy App", value: "VisionTherapyApp" },
              { option: "Vision Management App", value: "VisionManagementApp" },
              { option: "Chart App", value: "ChartApp" },
            ]}
            value={searchFilters.source}
            onChange={handleSearchInput}
            name={"source"}
            defaultOption={"Source"}
          />
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Start Date"
              className={styles.dateInput}
              value={searchFilters.startDate}
              onChange={(value) => setSearchFilters((prev) => ({ ...prev, startDate: value }))}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="End Date"
              className={styles.dateInput}
              value={searchFilters.endDate}
              onChange={(value) => setSearchFilters((prev) => ({ ...prev, endDate: value }))}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
          <Button
            className={styles.CustomSelect}
            text={"Search"}
            onClick={searchFunction}
            btnType={"primary"}
          />
        </div>
        <TicketBoardComponent
          data = {ticketData?.data || []}
          setShowTicketUpdate = {setShowTicketUpdate}
          handleOpenTicketUpdate = {handleOpenTicketUpdate}
          viewNavigate={handleNavigateViewTicket}
        />
        {showTicketUpdate && selectedTicket && (
          <div className={styles.modalOverlay} >
            <TicketUpdateComponent
              user = {selectedTicket}  
              type = {searchFilters.type}
              setUpdate={setShowTicketUpdate}
              refreshTickets={setRefreshTickets}
            />
          </div>
        )}
    </>
  )
};

export default ViewProgressPage;